import { inject, Injectable } from '@angular/core';
import { IAppRequest } from '@app/app.interface';
import { BaseHttpService } from '@services/http-base.service';
import { Observable } from 'rxjs';
import { IFilter, IFormFilterStructureGroup } from './form-filter.interface';

@Injectable({
    providedIn: 'root',
})
export class FormFilterService {
    private readonly http = inject(BaseHttpService);
    private readonly url = '/factor/front_filter';

    /**
     * Получение структуры формы поиска
     * @param id ID реестра
     */
    public getSettings(id: number): Observable<IAppRequest<IFormFilterStructureGroup[]>> {
        return this.http.client.get<any>(this.http.url + this.url + '/get_settings/?id=' + id, this.http.options);
    }

    /**
     * Сохранение структуры формы поиска
     * @param id ID реестра
     * @param data Структура групп и полей формы поиска
     */
    public saveSettings(id: number, data: IFormFilterStructureGroup[]): Observable<IAppRequest<null>> {
        return this.http.client.post<any>(
            this.http.url + this.url + '/save_settings/?id=' + id,
            data,
            this.http.options,
        );
    }

    /**
     * Получить превью данных формы поиска на основании заданной структуры формы поиска
     * @param id ID реестра
     * @param data Структура групп и полей формы поиска
     */
    public getPreview(id: number, data: IFormFilterStructureGroup[]): Observable<IAppRequest<IFilter>> {
        return this.http.client.post<any>(this.http.url + this.url + '/get_preview/?id=' + id, data, this.http.options);
    }

    /**
     * Создать новый сохранённый поиск
     * @param data данные
     */
    public createFilter(data: any): Observable<any> {
        return this.http.client.post<any>(this.http.url + this.url + '/copy_item', data, this.http.options);
    }

    /**
     * Удаление сохранённого поиска
     * @param id ID сохранённого поиска
     */
    public removeFilter(id: string): Observable<any> {
        return this.http.client.post<any>(this.http.url + this.url + '/delete', { id }, this.http.options);
    }
}
